import * as React from 'react';

interface GProps<DataType> {
    array: DataType[];
    onChange(array: DataType[]): void;
}

interface ComponentProps<DataType> {
    item: DataType;
    onChange(x: DataType): void;
    onDelete(): void;
}

function listaComponentes<DataType, P = {}>(
    Component: React.ComponentType<P & ComponentProps<DataType>>,
): React.FunctionComponent<P & GProps<DataType>> {
    return props => {
        const { array, onChange, ...rest } = props;

        return (
            <div>
                {array.map((data, index) => (
                    <Component
                        {...(rest as P)}
                        key={index}
                        item={data}
                        onChange={item => {
                            const otros = [...array];
                            otros[index] = item;
                            onChange(otros);
                        }}
                        onDelete={() => {
                            const otros = [...array];
                            otros.splice(index, 1);
                            onChange(otros);
                        }}
                    />
                ))}
            </div>
        );
    };
}

export default listaComponentes;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/ListaComponentes.tsx